const formatDate = (date) => {
    if (date === null || date === undefined || date === '') return '';

    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) return '';

    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    return `${day}.${month}.${parsedDate.getFullYear()}`;
};

export default formatDate;